//-----------------------------------------------------------------------
// GLOBAL VARIABLES 
//-----------------------------------------------------------------------
var facetExpandWidth = window.matchMedia('(min-width: 992px)'); // bootstrap 'lg' default value
var delimiter = "^";
//-----------------------------------------------------------------------
// GLOBAL FUNCTIONS
//-----------------------------------------------------------------------


var site = site || {};
site.Search = (function () {
    var showHideFacets = function () {
        if (facetExpandWidth.matches) {
            $('.js-nested-facet, .js-facet-panel').addClass('show');
            $('.js-collapse-icon').attr("aria-expanded", true);

            $('[id^=filter--]').each(function (i, el) {
                if ($(this).find('input:checked').length > 0) {
                    $(this).removeClass('collapse');
                    $(this).addClass('show');
                }
            });

        }
    }

    var scrollToReloadAnchor = function () {
        // Need to ensure we're below the header, the 5px is to ensure enough additional spacing
        var offset = $(".main-nav").height() + 5; 
        var position = $('#reload-anchor').offset().top - offset;
        $("body, html").animate({
            scrollTop: position
        }, 150);
        var lazyLoadInstance = new LazyLoad({
            elements_selector: ".lazy",
            use_native: true
        });
    }



    var buildQuery = function (page) {
        removeFromUrl('page');
        appendToUrl('page', page);
        var scopedProductCategory = $('#productSearchCategory').val();
        var p = getFacetsFromUrl();
        var searchTerm = $('#searchTextBox').val();
        if (searchTerm && searchTerm.length > 0) {
            appendToUrl("searchTerm", searchTerm);
        }
        let sortOrder = $("#sortOrder span.sortOrderOptions.activeOption").attr("data-option");
        if (sortOrder && sortOrder.length > 0 && sortOrder != "Select") {
            appendToUrl("sortOrder", sortOrder);
        }
        var pageSize = $("#pageSize").val();
        if (isNaN(pageSize)) {
            pageSize = 12;
        }
        return new searchRequestObject(searchTerm, page, searchfacets(p), sortOrder, scopedProductCategory, pageSize);
    };

    function getSuggestions(searchText, resourceType) {
        var query = { terms: searchText, resourceType };
        $.ajax({
            method: "GET",
            url: "/products/search",
            data: $.param(query),
            contentType: "application/json",
            dataType: "json"
        })
            .done(function (data) { processSuggestionResponse(data); })
            .fail(function (data) { console.log(data) });
    }

    function processSuggestionResponse(data) {
        $('#suggestionsContainer').html('');
        $('#suggestionsContainer').append(data).show();
        $('#suggestionsContainer').show();
    }

    function removeSuggestions() {
        $('#suggestionsContainer').html('').hide();
    }

    function removeSelectedFacets() {
        window.history.pushState("", "search", window.location.pathname.split('?')[0]);
    }
    function encodeData(data) {
        return Object.keys(data).map(function (key) {
            return [key, data[key]].map(encodeURIComponent).join("=");
        }).join("&");
    };

    function getFacetsFromUrl() {
        var params = getUrlParams();
        return params;
    }

    function getUrlParams() {
        var params = window.location.search.split('?')[1];
        if (params) {
            var obj = params.split("&").reduce(function (prev, curr, i, arr) {
                var p = curr.split("=");
                prev[decodeURIComponent(p[0])] = decodeURIComponent(p[1]);
                return prev;
            }, {});

            // Need to map the resource categories to the correct values.
            if ("resourceCategories" in obj) {
                var resourceCategory = obj.resourceCategories;

                var valuesToBeMapped = [
                    "SALES",
                    "LIT",
                    "MRCH",
                ];

                if (valuesToBeMapped.includes(resourceCategory)) {
                    obj.resourceCategories = "PRD|" + resourceCategory;
                }
            }

            return obj;
        }
        return {};
    };

    function removeFromUrl(key, val) {
        var params = getUrlParams();
        if (params[key]) {
            if (key == 'bodySystems' || key == 'healthInterests' || key == 'dietaryNeeds') {
                if (params[key].split(delimiter).length == 1) {
                    delete params[key];
                } else if (params[key].split(delimiter).includes(val)) {
                    var p = params[key].split(delimiter);
                    params[key] = p.filter(function (value, i, arr) {
                        return value != val;
                    }).join(delimiter);
                }
            }
            else {
                if (!params[key].split(delimiter).includes(val) && val == 'true') {
                    var p = params[key].split(delimiter);
                    params[key] = p.splice(p.indexOf(val, 1));
                } else {
                    delete params[key];
                }
            }
        }
        var d = encodeData(params);
        if (d.length > 0) {
            window.history.pushState("", "search", window.location.pathname.split('?')[0] + '?' + d);
        } else {
            window.history.pushState("", "search", window.location.pathname.split('?')[0]);
        }
        return params;
    }

    function appendToUrl(key, val) {
        var valuesToBeMapped = [
            "PRD|SALES",
            "PRD|LIT",
            "PRD|MRCH",
        ];

        var params = getUrlParams();

        // Need to remap the resource categories to the correct url values.
        if ("resourceCategories" in params) {
            let resourceCategory = params["resourceCategories"];

            if (valuesToBeMapped.includes(resourceCategory)) {
                resourceCategory = resourceCategory.substring(resourceCategory.indexOf("|") + 1);
                params["resourceCategories"] = resourceCategory;
            }
        }

        if (key === "resourceCategories") {

            if (valuesToBeMapped.includes(val)) {
                val = val.substring(val.indexOf("|") + 1);
            }
        }

        if (params[key]) {
            if (!params[key].split(delimiter).includes(val) && val != 'true') {
                params[key] = params[key] + delimiter + val;
            }
        } else {
            params[key] = val;
        }
        var d = encodeData(params);
        window.history.pushState("", "search", window.location.pathname.split('?')[0] + '?' + d);
        return params;
    };

    
    function addFacetPill(key, val, fieldName) {
        // Need to check if the facet already exists.
        var existingPills = [];
        var $pillsContainer = $('.js-facet-pills-container');

        $pillsContainer.find(".js-facet-pill").each(function () {
            var facetKey = $(this).data("facetKey");
            existingPills.push(facetKey);
        });

        // Short circuit if the pill already exists or is sort by or vals are null
        if (existingPills.includes(key) || fieldName == "sortOrder" || key == null || val == null) {
            return;
        }

        $('.js-facet-pills-container').removeClass('d-none').addClass('d-flex');
        var markup = '<button type="button" class="btn btn-sm btn-outline-primary js-facet-pill" data-facet-fieldname="{{fieldname}}" data-facet-key="{{key}}" aria-label="Active Filter">{{val}} <span class="js-remove-filter ms-2">&times;</span></button>';
        markup = markup.replace("{{key}}", key);
        markup = markup.replace("{{val}}", val);
        markup = markup.replace("{{fieldname}}", fieldName);
        $('.js-facet-pills-container').append(markup);
    }

    function addSelectedFacet(key, val, fieldName) {
        const facet = $('.js-facet-filter[data-value="' + key + '"]')[0];
        if (typeof facet != 'undefined' || facet != null) {
            if (!facet.checked) {
                $(facet).prop('checked', true);
            }
        }
        if (key.includes('||')) {
            let newVal = key.split(' || ');
            const parentFacet = $('.js-facet-filter[data-value="' + newVal[0] + '"]')[0];
            if (!parentFacet.checked) {
                $(parentFacet).prop('checked', true);
            }
        }
    }




    function removeFacetPill(key) {
        $('.js-facet-pills-container [data-facet-key="' + key + '"]').remove();
        if ($('.js-facet-pills-container').children('.js-facet-pill').length == 0) {
            $('.js-facet-pills-container').removeClass('d-flex').addClass('d-none');
        }
    }

    function searchRequestObject(term, page, facets, sortOrder, scopedProductCategory, pageSize) {
        this.term = term;
        this.page = page;
        this.searchfacets = facets;
        this.sortOrder = sortOrder;
        this.productSearchCategory = scopedProductCategory;
        this.pageSize = parseInt(pageSize);
    }

    function searchfacets(params) {
        var facets = {};
        $.each(params, function (fieldName, e) {
            if (fieldName != "searchTerm") {
                addFacet(facets, params, fieldName);
            }
        });
        return facets;
    }

    function addFacet(facets, params, fieldName) {
        facets[fieldName] = [];
        $.each(params[fieldName].split(delimiter), function (i, e) {
            facets[fieldName][i] = {};
            facets[fieldName][i].value = e;
            facets[fieldName][i].fieldName = fieldName;
        });
    }

    function autocompleteQuery(searchTerm) {
        $('#searchTextBox').val(searchTerm);
        $('#searchSubmitButton').click();
    }

    var showHideReset = function () {
        if ($('.js-facet-filter:checked').length === 0) {
            $('.js-filter-reset').addClass('d-none');
        } else {
            $('.js-filter-reset').removeClass('d-none');
        }
    }

    function focusedResourceType() {
        if ($('#productSearchCategory').val() == "GlobalSearch") {
            return "";
        }
        return "PRD";
    }
    function bindSuggestionPageEvents() {
        var liSelected;
        var resourceType = focusedResourceType();
        $('#searchTextBox').on('keyup', function (e) {
            var searchText = $('#searchTextBox').val();
            if (searchText.length >= 3) {
                var li = $('.search-suggestion__item');
                if (e.keyCode === 38) {
                    if (liSelected) {
                        liSelected.removeClass('active');
                        next = liSelected.prev();
                        if (next.length > 0) {
                            liSelected = next.addClass('active');
                        } else {
                            liSelected = li.last().addClass('active');
                        }
                    } else {
                        liSelected = li.last().addClass('active');
                    }
                } else if (e.keyCode === 40) {
                    if (liSelected) {
                        liSelected.removeClass('active');
                        next = liSelected.next();
                        if (next.length > 0) {
                            liSelected = next.addClass('active');
                        } else {
                            liSelected = li.eq(0).addClass('active');
                        }
                    } else {
                        liSelected = li.eq(0).addClass('active');
                    }
                } else if (e.keyCode === 13) {
                    var $visuallySelectedItem = $('.search-suggestion__item.active');
                    if ($visuallySelectedItem.length > 0) {
                        $('#searchTextBox').val($visuallySelectedItem.text());
                        $('#searchSubmitButton').click();
                        removeSuggestions();
                    } else {
                        $('#searchSubmitButton').click();
                        removeSuggestions();
                    }
                } else {
                    getSuggestions(searchText, resourceType);
                }
            } else {
                if ((e.keyCode == 8 || e.keyCode == 46)) {
                    removeSuggestions();
                } else if (e.keyCode === 13) {
                    $('#searchSubmitButton').click();
                }
            }
        })

        $(document).on("click", function (e) {
            var target = e.target;
            if ('.grid-search__panel:visible') {
                if (!$(target).is('#searchTextBox') && !$(target).is('.search-suggestion__item') && !$(target).is('#searchSubmitButton')) {
                    removeSuggestions();
                }
            }
        });
    }

    function setFacetPillsFromQueryString() {
        if (location.search !== '') {
            const pills = decodeURIComponent(location.search.replace('?', '')).split("&").flatMap(y => {
                let [key, value] = y.split('=');
                if (key == 'bodySystems' || key == 'healthInterests' || key == 'dietaryNeeds') {

                    return value.split('^').map(y2 => {
                        return {
                            key: y2,
                            val: y2.split('||').pop().trim(),
                            fieldName: key
                        };
                    })
                }
                if (key == '_gl') {
                    removeFromUrl('_gl')
                }

                if (key === "resourceCategories") {
                    if (value === "SALES") {
                        value = "Product";
                    } else if (value === "GENERAL") {
                        value = "Education";
                    } else if (value === "LIT") {
                        value = "Literature";
                    } else if (value === "MRCH") {
                        value = "Merchandise";
                    }
                }

                let facets = site.Search.getFacetsFromUrl();
                let resourceCategorySelector = facets["resourceCategories"]?.replace("|", "_") ?? "";
                let activeContentType = $('#filter-resourceType-' + resourceCategorySelector);

                if (typeof activeContentType != "undefined" && activeContentType != null && activeContentType.length == 1 && value == activeContentType[0].dataset.value) {
                    return {
                        fieldName: activeContentType[0].dataset.fieldname,
                        key: activeContentType[0].dataset.value,
                        val: activeContentType[0].dataset.displayname
                    };
                }
                return {
                    fieldName: key,
                    key: value,
                    val: value
                };


            }).filter(y => y.fieldName !== "page" && y.fieldName !== 'searchTerm' && y.fieldName !== 'utm_medium' && y.fieldName !== '_hsmi' && y.fieldName !== '_hsenc' && y.fieldName !== 'utm_source' && y.fieldName !== 'utm_content' && y.fieldName !== '_ga' && y.fieldName !== '_gl');
            pills.forEach(pill => addFacetPill(pill.key, pill.val, pill.fieldName));
            pills.forEach(pill => addSelectedFacet(pill.key, pill.val, pill.fieldName));
        }
    }

    return {
        bindSuggestionPageEvents: bindSuggestionPageEvents,
        setFacetPillsFromQueryString: setFacetPillsFromQueryString,
        showHideReset: showHideReset,
        autocompleteQuery: autocompleteQuery,
        appendToUrl: appendToUrl,
        removeFromUrl: removeFromUrl,
        getSuggestions: getSuggestions,
        buildQuery: buildQuery,
        scrollToReloadAnchor: scrollToReloadAnchor,
        showHideFacets: showHideFacets,
        removeSelectedFacets: removeSelectedFacets,
        removeSuggestions: removeSuggestions,
        addFacetPill: addFacetPill,
        removeFacetPill: removeFacetPill,
        getFacetsFromUrl: getFacetsFromUrl,
        searchRequestObject: searchRequestObject,
        addSelectedFacet: addSelectedFacet
    }

}());